export default {
  svgData: [
    {
      id: "slide2tv1",
      assets: [],
      name: "TV",
      label: "slide2tv1"
    },
    {
      id: "slide2easel1",
      name: "Easel1",
      url: "https://s3.us-east-2.amazonaws.com/cdn.scoutfeedback.com/gdot-workshop/sr316-bundle2/oconee/oconee-connector/oconee-connector-concept-display.pdf",
      label: "slide2easel1"
    },
    {
      id: "slide2easel2",
      name: "Easel2",
      assets: [
        "https://s3.us-east-2.amazonaws.com/cdn.scoutfeedback.com/gdot-workshop/sr316-bundle2/oconee/oconee-connector/oconee-connector-typical-section-page-1.jpg",
        "https://s3.us-east-2.amazonaws.com/cdn.scoutfeedback.com/gdot-workshop/sr316-bundle2/oconee/oconee-connector/oconee-connector-typical-section-page-2.jpg"
      ],
      label: "slide2easel2"
    },
    {
      id: "slide2easel3",
      name: "Easel3",
      assets: [
        "https://s3.us-east-2.amazonaws.com/cdn.scoutfeedback.com/gdot-workshop/sr316-bundle2/oconee/oconee-connector/oconee-connector-potential-detour.jpg"
      ],
      label: "slide2easel3"
    },
    {
      id: "slide2display1",
      name: "Display1",
      url: "https://s3.us-east-2.amazonaws.com/cdn.scoutfeedback.com/gdot-workshop/sr316-bundle2/oconee/oconee-connector/oconee-connector-project-handout.pdf",
      label: "slide2display1"
    },
    {
      id: "slide2avatar1"
    },
    {
      id: "slide2bubble1"
    },
    {
      id: "slide2speech1"
    }
  ],
  slideTitle: "Oconee Connector",
  helpText: ` 
    <p class="text-justify help">The <strong>SR 8/SR 316/US 29 at Oconee Connector (P.I. No.
      0013769)</strong>, also known as SR 316 Bundle 2 Design-Build projects,
      is part of a series of roadway improvement projects along SR 316 from SR
      20 in Gwinnett County to SR 10 in Athens, Oconee County. The need for
      these projects is to upgrade sections of SR 316 to improve traffic flow
      and reduce the potential for crashes.</p>
      <p class="text-justify help">The SR 8/SR 316/US 29 at Oconee Connector (P.I. No. 0013769)
      proposes the following:</p>
      <ul>
      <li><p class="text-justify help">Remove the existing at-grade, signalized intersection at CR
      929/Oconee Connector.</p></li>
      <li><p class="text-justify help">Create a grade-separated partial cloverleaf interchange at CR
      929/Oconee Connector.</p></li>
      </ul>
      <p class="text-justify help">A potential detour may be needed for a short-term period to allow for
      the completion of a small section of the proposed eastbound SR 8/SR
      316/US 29 exit ramp to CR 929/Oconee Connector. Please refer to the
      Project Handout and Proposed Detour Display for more information.</p>
      <ul>
      <li><blockquote>
      <p class="text-justify help"><strong><u>Project Handout</u></strong> – The handout on the
      table provides a summary of the proposed improvements, project details,
      and purpose of the project.</p>
      </blockquote></li>
      <li><blockquote>
      <p class="text-justify help"><strong><u>Concept Display/Roll Plot</u></strong> – The easel in
      the middle offers a detailed look of the project corridor. Refer to the
      Legend to help you navigate the concept display.</p>
      </blockquote></li>
      <li><blockquote>
      <p class="text-justify help"><strong><u>Project Visualization</u></strong> – The animated
      rendering provides a 3D aerial perspective of the projects.</p>
      </blockquote></li>
      <li><blockquote>
      <p class="text-justify help"><strong><u>Typical Section</u></strong> – The easel at the end
      showcases the various cross sections, or typical sections, based on the
      current project design. These sections represent the roadway and major
      elements that are the basis for construction.</p>
      </blockquote></li>
      <li><blockquote>
      <p class="text-justify help"><strong><u>Proposed Detour</u></strong> – This display provides a
      visual representation of the route for the potential detour needed
      during construction. This detour would affect the eastbound State Route
      316 traffic wanting to access the Oconee Connector.</p>
      </blockquote></li>
      </ul>
      <p class="text-justify help">Once your tour of the Project Design station is complete, we
      invite you to visit the next station by clicking on the right arrow or
      selecting your station of choice from the navigation sidebar on the
      right. For additional information, 
      click the following button <i class="mdi mdi-account-question" style="font-size:2em;"></i>
      to learn about the specific station or the <i class="mdi mdi-information-outline" style="font-size:2em;"></i>
      to see this message again after you close it out. To return to the project website, 
      select the <i class="mdi mdi-exit-to-app" style="font-size:2em;"></i>icon.</p>
       `,
  aboutText: `
  <p class="text-justify help">In this space, we hope to help you better understand and
  visualize the project design for the <strong>SR 8/SR 316/US 29 at Oconee
  Connector (P.I. No. 0013769).</strong> The purpose of this interchange
  improvement project is to improve mobility and reduce the number of
  potential crashes at the intersection.</p>
  <p class="text-justify help">The Handout provides a detailed overview of the proposed
  improvements. The Concept Display, or roll plots, and Project
  Visualization offers an aerial view of the project limits and proposed
  improvements. The Typical Sections provide a visual representation of
  the various cross sections of roadway and major elements that are needed
  for construction.</p>
  <p class="text-justify help">Once your tour of the Project Design space is complete, we invite
  you to visit the next station by clicking on the right arrow or
  selecting your station of choice from the sidebar on the right.</p>
    `,
};
